import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronLeft, FiChevronRight, FiCheck } from 'react-icons/fi';
import '../styles/OnboardingModal.css';

const slides = [
    {
        title: 'Welcome to DexWallet',
        description: 'A secure, modern wallet for TON and tokens. Fast, private, and easy to use.',
        image: '/assets/onboarding/welcome.png',
    },
    {
        title: 'Secure Your Wallet',
        description: 'Back up your recovery phrase and set a strong PIN. Your security is our priority.',
        image: '/assets/onboarding/secure.png',
    },
    {
        title: 'Send & Receive',
        description: 'Easily send and receive TON and tokens. Enjoy fast, low-fee transactions.',
        image: '/assets/onboarding/send-receive.png',
    },
    {
        title: 'Manage Tokens',
        description: 'Track, add, and manage all your tokens in one place. Beautiful, real-time portfolio.',
        image: '/assets/onboarding/tokens.png',
    },
    {
        title: 'Customize & Explore',
        description: 'Personalize your experience in Settings. Explore new features and stay updated.',
        image: '/assets/onboarding/settings.png',
    },
];

const OnboardingModal = ({ onClose }) => {
    const [step, setStep] = useState(0);

    const handleNext = () => setStep((s) => Math.min(s + 1, slides.length - 1));
    const handleBack = () => setStep((s) => Math.max(s - 1, 0));
    const handleFinish = () => {
        localStorage.setItem('hasSeenOnboarding', 'true');
        onClose();
    };

    return (
        <div className="onboarding-modal-overlay" role="dialog" aria-modal="true">
            <div className="aurora-bg overlay-bg"> {/* Subtle background for modal focus */}
                <div className="aurora-blob aurora-1" />
            </div>

            <motion.div
                className="glass-card onboarding-card"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.4 }}
            >
                <button onClick={onClose} className="skip-btn" aria-label="Skip">Skip</button>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={step}
                        className="slide-content"
                        initial={{ x: 20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -20, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div className="image-container">
                            {/* Use a placeholder div or check if images exist. Assuming images exist based on previous file */}
                            <img src={slides[step].image} alt="" className="slide-image" onError={(e) => e.target.style.display = 'none'} />
                            <div className="image-glow" />
                        </div>

                        <h2 className="slide-title">{slides[step].title}</h2>
                        <p className="slide-desc">{slides[step].description}</p>
                    </motion.div>
                </AnimatePresence>

                <div className="modal-footer">
                    <div className="dots-indicator">
                        {slides.map((_, i) => (
                            <span key={i} className={`dot ${i === step ? 'active' : ''}`} />
                        ))}
                    </div>

                    <div className="nav-actions">
                        <button
                            onClick={handleBack}
                            disabled={step === 0}
                            className="icon-btn-round secondary"
                        >
                            <FiChevronLeft />
                        </button>

                        {step < slides.length - 1 ? (
                            <button
                                onClick={handleNext}
                                className="crystal-button btn-primary small-btn"
                            >
                                <span>Next</span>
                                <FiChevronRight />
                                <div className="btn-shine" />
                            </button>
                        ) : (
                            <button
                                onClick={handleFinish}
                                className="crystal-button btn-primary small-btn"
                            >
                                <span>Start</span>
                                <FiCheck />
                                <div className="btn-shine" />
                            </button>
                        )}
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default OnboardingModal;
